import '../chunk-H27DPR2I.js';
import '../chunk-KLRGM47X.js';
import '../chunk-XR6TNFQL.js';
import { unwrapData } from '../chunk-HIWBYL4O.js';
import '../chunk-24RJERVQ.js';
import '../chunk-X34AGPO3.js';
import '../chunk-L6V3D5WY.js';
import '../chunk-7B3IWQPL.js';
import '../chunk-5WIUKZF6.js';
import '../chunk-HCZGW64N.js';
import '../chunk-OIPP4WAH.js';
import '../chunk-IAXDOK4V.js';
import '../chunk-BFUJOKOR.js';
import '../chunk-DQNP4KXT.js';
import '../chunk-WVLHT3DL.js';
import '../chunk-NJHJJJN3.js';
import { isGlobalTenantSegment } from '../chunk-UFKMEU5Q.js';
import '../chunk-BJ3WKLB6.js';
import '../chunk-INX63VAT.js';
import '../chunk-3QCA6IWY.js';
import '../chunk-6B5KO6TH.js';
import '../chunk-3QN2VZ56.js';
import '../chunk-K2KDWL5E.js';
import '../chunk-2I3QH64T.js';
import '../chunk-O2TUCS6S.js';
import '../chunk-DRKG2ORU.js';
import { toHexChainId } from '../chunk-3K2HDD4E.js';
import '../chunk-GPJ572YS.js';
import '../chunk-N7SZ66QO.js';
import '../chunk-LJIKHB2F.js';
import '../chunk-AHISJLEK.js';
import '../chunk-QXYP3KHC.js';
import '../chunk-O5TCTRWM.js';
import '../chunk-O3OIBNP7.js';
import '../chunk-PZ5AY32C.js';

// src/contracts/block.ts
var BLOCK_TAGS = ["latest", "earliest", "safe", "finalized", "pending"];
function parseBlock(text) {
  const t = text.trim().toLowerCase();
  if (!t || t === "latest") return void 0;
  if (BLOCK_TAGS.includes(t)) return { blockTag: t };
  try {
    return { blockNumber: BigInt(t) };
  } catch {
    return void 0;
  }
}
function blockKey(block) {
  if (block?.blockNumber != null) return `#${block.blockNumber.toString()}`;
  if (block?.blockTag) return block.blockTag;
  return "latest";
}
function blockToJson(block) {
  if (!block) return void 0;
  const out = {};
  if (block.blockNumber != null) out.blockNumber = block.blockNumber.toString();
  if (block.blockTag) out.blockTag = block.blockTag;
  return Object.keys(out).length > 0 ? out : void 0;
}
function blockFromJson(json) {
  if (!json) return void 0;
  const out = {};
  if (json.blockNumber != null && json.blockNumber !== "") {
    try {
      out.blockNumber = BigInt(json.blockNumber);
    } catch {
    }
  }
  if (json.blockTag) out.blockTag = json.blockTag;
  return Object.keys(out).length > 0 ? out : void 0;
}
function blockArg(block) {
  if (block?.blockNumber != null) return { blockNumber: block.blockNumber };
  if (block?.blockTag) return { blockTag: block.blockTag };
  return {};
}

// src/contracts/ref.ts
function contractRefKey(ref) {
  return `${ref.chainId.toLowerCase()}:${ref.address.toLowerCase()}@${blockKey(ref.block)}`;
}
function addressKey(ref) {
  return `${ref.chainId.toLowerCase()}:${ref.address.toLowerCase()}`;
}
function chainIdToNumber(chainId) {
  const hex = toHexChainId(chainId);
  if (!hex) {
    const raw = chainId.includes(":") ? chainId.slice(chainId.lastIndexOf(":") + 1) : chainId;
    const n = Number(raw);
    return Number.isSafeInteger(n) && n > 0 ? n : void 0;
  }
  try {
    const n = Number(BigInt(hex));
    return Number.isSafeInteger(n) ? n : void 0;
  } catch {
    return void 0;
  }
}

// src/contracts/proxy.ts
var ProxyKind = {
  /** EIP-1967 standard implementation slot. */
  EIP1967: "eip1967",
  /** EIP-1822 UUPS (implementation lives in the 1967 slot, upgrade logic in impl). */
  UUPS: "uups",
  /** EIP-1967 beacon slot → beacon contract returns the implementation. */
  BEACON: "beacon",
  /** Transparent proxy (admin slot present). */
  TRANSPARENT: "transparent",
  /** EIP-2535 diamond (facets per selector). */
  DIAMOND: "diamond",
  /** Detected via a non-standard pattern. */
  CUSTOM: "custom",
  UNKNOWN: "unknown"
};
function directChain(address, truncated) {
  return {
    root: address,
    hops: [],
    effectiveAddress: address,
    isProxy: false,
    ...truncated ? { truncated } : {}
  };
}

// src/contracts/override.ts
var OVERRIDE_RUNGS = ["user", "tenant", "org", "customer"];
function availableOverrideRungs(identity = {}) {
  const org = !isGlobalTenantSegment(identity.orgId);
  const tenant = org && !isGlobalTenantSegment(identity.tenantId);
  return OVERRIDE_RUNGS.filter((rung) => rung === "user" ? tenant && !isGlobalTenantSegment(identity.userId) : rung === "tenant" ? tenant : rung === "org" ? org : !isGlobalTenantSegment(identity.customerId));
}
var RUNG_LABELS = {
  user: "User",
  tenant: "Tenant",
  org: "Org",
  customer: "Customer",
  system: "System default"
};
function scopeRungLabel(scope) {
  if (!scope) return null;
  if (!scope.includes("#")) {
    const rung = scope.trim().toLowerCase();
    return rung in RUNG_LABELS ? RUNG_LABELS[rung] : null;
  }
  const [customer, org, tenant, user] = scope.split("#");
  if (user && user !== "*") return RUNG_LABELS.user;
  if (tenant && tenant !== "main") return RUNG_LABELS.tenant;
  if (org && org !== "main") return RUNG_LABELS.org;
  if (customer && customer !== "*") return RUNG_LABELS.customer;
  return RUNG_LABELS.system;
}
function isInherited(own, resolved) {
  if (!resolved || !own) return false;
  return own !== resolved;
}
function overrideQuery(opts) {
  const query = {};
  if (opts.scope) query.scope = opts.scope;
  if (opts.block != null) query.block = opts.block.toString();
  return query;
}
function toProvenance(wire) {
  return {
    explanation: Array.isArray(wire?.explanation) ? wire.explanation : [],
    evidence: Array.isArray(wire?.evidence) ? wire.evidence : [],
    confidence: typeof wire?.confidence === "number" ? wire.confidence : null,
    lifecycle: wire?.lifecycle ?? null
  };
}
function hasProvenance(p) {
  if (!p) return false;
  return p.explanation.length > 0 || p.evidence.length > 0 || p.confidence != null;
}
function formatBlockWindow(window) {
  const from = window.valid_from_block.toLocaleString();
  if (window.valid_to_block == null) return `from block ${from}`;
  return `blocks ${from} \u2013 ${(window.valid_to_block - 1).toLocaleString()}`;
}
function windowViewBlock(window) {
  if (window.valid_from_block > 0) return BigInt(window.valid_from_block);
  if (window.valid_to_block == null) return null;
  return BigInt(Math.max(window.valid_to_block - 1, 0));
}
function windowCovers(window, block) {
  if (block == null) return window.valid_to_block == null;
  const b = BigInt(block);
  if (b < BigInt(window.valid_from_block)) return false;
  return window.valid_to_block == null || b < BigInt(window.valid_to_block);
}

// src/contracts/proxy-overrides.ts
function normalizeResolution(wire, chain, address) {
  const base = wire ?? { chain_id: chain, address, is_proxy: false };
  if (base.valid_to_block !== void 0) return base;
  const until = base.valid_until_block;
  return { ...base, valid_to_block: typeof until === "number" ? until + 1 : null };
}
function normalizeWindow(w) {
  const validFrom = typeof w.valid_from_block === "number" ? w.valid_from_block : typeof w.start_block === "number" ? w.start_block : 0;
  const validTo = w.valid_to_block !== void 0 ? w.valid_to_block : w.end_block !== void 0 ? w.end_block ?? null : null;
  return {
    ...w,
    valid_from_block: validFrom,
    valid_to_block: validTo,
    implementations: w.implementations ?? w.implementation_addresses ?? null,
    address: w.address ?? w.proxy_address,
    detection_methods: w.detection_methods ?? (typeof w.source_strategy === "string" ? [w.source_strategy] : null)
  };
}
function proxyOverrideRequestBody(input) {
  const body = {
    is_proxy: input.is_proxy,
    implementations: input.implementations
  };
  if (input.pattern) body.pattern = input.pattern;
  if (input.valid_from_block != null) body.valid_from_block = input.valid_from_block;
  if (input.valid_to_block != null) body.valid_to_block = input.valid_to_block;
  if (input.reason) body.reason = input.reason;
  if (input.evidence_url) body.evidence_url = input.evidence_url;
  if (input.confidence != null) body.confidence = input.confidence;
  return body;
}
function createProxyOverridesClient(client, options = {}) {
  const base = options.basePath ?? "/proxy-overrides";
  const ref = (chain, address) => `${base}/${encodeURIComponent(chain)}/${encodeURIComponent(address)}`;
  const query = (opts) => overrideQuery({ scope: opts?.scope ?? null, block: opts?.block ?? null });
  return {
    async resolve(chain, address, opts) {
      const wire = unwrapData(
        await client.get(ref(chain, address), {
          query: query(opts),
          signal: opts?.signal,
          // Never cached: a resolve is what an operator just changed, and a stale
          // hit here is indistinguishable from "my pin did not take".
          cacheTtlMs: 0
        })
      );
      return normalizeResolution(wire, chain, address);
    },
    async history(chain, address, opts) {
      const wire = unwrapData(
        await client.get(`${ref(chain, address)}/history`, {
          query: query(opts),
          signal: opts?.signal,
          cacheTtlMs: 0
        })
      );
      return {
        chain_id: wire?.chain_id ?? chain,
        address: wire?.address ?? address,
        count: wire?.count ?? 0,
        windows: Array.isArray(wire?.windows) ? wire.windows.map(normalizeWindow) : [],
        overrides: Array.isArray(wire?.overrides) ? wire.overrides : [],
        scope: wire?.scope ?? null,
        scope_rung: wire?.scope_rung ?? null,
        overrides_truncated_rungs: Array.isArray(wire?.overrides_truncated_rungs) ? wire.overrides_truncated_rungs : []
      };
    },
    async put(chain, address, input, opts) {
      const wire = unwrapData(
        await client.put(ref(chain, address), proxyOverrideRequestBody(input), {
          query: query(opts),
          signal: opts?.signal
        })
      );
      return {
        chain_id: wire?.chain_id ?? chain,
        address: wire?.address ?? address,
        is_proxy: wire?.is_proxy ?? input.is_proxy,
        implementations: wire?.implementations ?? input.implementations,
        pattern: wire?.pattern ?? input.pattern ?? "manual",
        scope: wire?.scope ?? null,
        scope_rung: wire?.scope_rung ?? null,
        override_id: wire?.override_id ?? null,
        target: wire?.target ?? null,
        valid_from_block: wire?.valid_from_block ?? input.valid_from_block ?? 0,
        valid_to_block: wire?.valid_to_block ?? input.valid_to_block ?? null,
        ...toProvenance(wire)
      };
    },
    async remove(chain, address, opts) {
      const wire = unwrapData(
        await client.delete(ref(chain, address), {
          query: query(opts),
          signal: opts?.signal
        })
      );
      return {
        deleted: wire?.deleted ?? 0,
        scope: wire?.scope ?? null,
        scope_rung: wire?.scope_rung ?? null
      };
    },
    async purge(chain, address, opts) {
      const wire = unwrapData(
        await client.delete(ref(chain, address), {
          query: { purge: "true" },
          signal: opts?.signal
        })
      );
      return {
        deleted: wire?.deleted ?? 0,
        scope: wire?.scope ?? null,
        scope_rung: wire?.scope_rung ?? null,
        purged: true
      };
    },
    async index(chain, address, opts) {
      const body = { chain_id: chain, address };
      if (opts?.fromBlock !== void 0) body.from_block = opts.fromBlock;
      if (opts?.toBlock !== void 0) body.to_block = opts.toBlock;
      const wire = unwrapData(
        await client.post(`${base}/index`, body, { signal: opts?.signal })
      );
      return {
        accepted: wire?.accepted ?? false,
        message_id: wire?.message_id ?? null,
        chain_id: wire?.chain_id ?? chain,
        address: wire?.address ?? address
      };
    }
  };
}

// src/contracts/detect.ts
var EIP1967_IMPL_SLOT = "0x360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc";
var EIP1967_BEACON_SLOT = "0xa3f0ad74e5423aebfd80d3ef4346578335a9a72aeaee59ff6cb3582b35133d50";
var EIP1967_ADMIN_SLOT = "0xb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d6103";
var OZ_LEGACY_IMPL_SLOT = "0x7050c9e0f4ca769c69bd3a8ef740bc37934f8e2c036e5a723fd8ee048ed3f8c3";
var ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
function addressFromStorageWord(word) {
  if (!word) return null;
  const hex = word.slice(2).padStart(64, "0");
  const addr = `0x${hex.slice(24)}`.toLowerCase();
  return addr === ZERO_ADDRESS ? null : addr;
}
var BEACON_ABI = [
  { type: "function", name: "implementation", stateMutability: "view", inputs: [], outputs: [{ type: "address" }] }
];

// src/contracts/chain.ts
async function detectHop(address, deps) {
  const { readStorage, readBeaconImplementation } = deps;
  const implWord = await readStorage(address, EIP1967_IMPL_SLOT);
  const impl = addressFromStorageWord(implWord);
  if (impl) {
    const adminWord = await readStorage(address, EIP1967_ADMIN_SLOT).catch(() => void 0);
    const isTransparent = addressFromStorageWord(adminWord) != null;
    return {
      address: impl,
      kind: isTransparent ? ProxyKind.TRANSPARENT : ProxyKind.EIP1967,
      slot: EIP1967_IMPL_SLOT
    };
  }
  const beaconWord = await readStorage(address, EIP1967_BEACON_SLOT);
  const beacon = addressFromStorageWord(beaconWord);
  if (beacon) {
    const beaconImpl = readBeaconImplementation ? await readBeaconImplementation(beacon).catch(() => null) : null;
    return {
      address: beaconImpl ?? beacon,
      kind: ProxyKind.BEACON,
      slot: EIP1967_BEACON_SLOT,
      beacon
    };
  }
  const legacyWord = await readStorage(address, OZ_LEGACY_IMPL_SLOT);
  const legacy = addressFromStorageWord(legacyWord);
  if (legacy) return { address: legacy, kind: ProxyKind.CUSTOM, slot: OZ_LEGACY_IMPL_SLOT };
  return null;
}
async function resolveProxyChain(root, deps) {
  const maxHops = deps.maxHops ?? 5;
  const hops = [];
  const visited = /* @__PURE__ */ new Set([root.toLowerCase()]);
  let current = root;
  let truncated;
  for (let i = 0; i < maxHops; i += 1) {
    let hop;
    try {
      hop = await detectHop(current, deps);
    } catch {
      truncated = "probe-failed";
      break;
    }
    if (!hop) break;
    const next = hop.address.toLowerCase();
    if (visited.has(next)) {
      truncated = "cycle";
      break;
    }
    hops.push(hop);
    visited.add(next);
    if (hop.kind === ProxyKind.BEACON && hop.address === hop.beacon) {
      truncated = "beacon-unresolved";
      break;
    }
    current = hop.address;
    if (i === maxHops - 1) truncated = "max-hops";
  }
  if (hops.length === 0) return directChain(root, truncated);
  return {
    root,
    hops,
    effectiveAddress: hops[hops.length - 1].address,
    isProxy: true,
    ...truncated ? { truncated } : {}
  };
}
function proxyChainFromAddresses(root, implementations) {
  const impls = (implementations ?? []).filter(Boolean);
  if (impls.length === 0) return directChain(root);
  const hops = impls.map((address) => ({ address, kind: ProxyKind.EIP1967 }));
  return { root, hops, effectiveAddress: impls[impls.length - 1], isProxy: true };
}

// src/contracts/reader.ts
function logBlock(value) {
  return value == null ? void 0 : typeof value === "bigint" ? value.toString() : value;
}
function createBackendContractReader(options) {
  const { fetcher, storageFetcher, logsFetcher, id = "backend" } = options;
  return {
    id,
    async read(ref, req, opts) {
      const [outcome] = await fetcher({
        chainId: ref.chainId,
        address: ref.address,
        block: blockToJson(ref.block),
        calls: [{ functionName: req.functionName, args: req.args, abi: req.abi }],
        // `BackendReadRequest.signal` was declared and never populated — nothing
        // could reach it, so a host that wired it into `fetch` was cancelling on
        // a permanently-undefined signal.
        signal: opts?.signal
      });
      if (!outcome || outcome.status === "failure") {
        throw outcome?.error ?? new Error(`Backend read failed for ${req.functionName}`);
      }
      return outcome.data;
    },
    async readMany(ref, reqs, opts) {
      if (reqs.length === 0) return [];
      return fetcher({
        chainId: ref.chainId,
        address: ref.address,
        block: blockToJson(ref.block),
        calls: reqs.map((r) => ({ functionName: r.functionName, args: r.args, abi: r.abi })),
        signal: opts?.signal
      });
    },
    ...storageFetcher ? {
      getStorageAt(ref, slot, opts) {
        return storageFetcher({
          chainId: ref.chainId,
          address: ref.address,
          slot,
          block: blockToJson(ref.block),
          signal: opts?.signal
        });
      }
    } : {},
    ...logsFetcher ? {
      getLogs(ref, query, opts) {
        return logsFetcher({
          chainId: ref.chainId,
          address: ref.address,
          fromBlock: logBlock(query?.fromBlock),
          // The ref's pinned block is the range's upper bound when the query
          // does not name one — the same rule the RPC reader applies, and
          // what `ContractLogQuery.toBlock` documents. Dropping it meant a
          // pinned explorer asked a backend for logs up to the HEAD and then
          // cached them under the pinned block's key.
          toBlock: logBlock(query?.toBlock ?? ref.block?.blockNumber ?? ref.block?.blockTag),
          topics: query?.topics,
          signal: opts?.signal
        });
      }
    } : {}
  };
}
function readerProxyDeps(reader, ref, maxHops) {
  if (!reader.getStorageAt) return null;
  const getStorageAt = reader.getStorageAt.bind(reader);
  return {
    maxHops,
    readStorage: (address, slot) => getStorageAt({ ...ref, address }, slot),
    readBeaconImplementation: async (beacon) => {
      try {
        const impl = await reader.read({ ...ref, address: beacon }, {
          abi: BEACON_ABI,
          functionName: "implementation"
        });
        return impl ?? null;
      } catch {
        return null;
      }
    }
  };
}

export { BEACON_ABI, BLOCK_TAGS, EIP1967_ADMIN_SLOT, EIP1967_BEACON_SLOT, EIP1967_IMPL_SLOT, OVERRIDE_RUNGS, OZ_LEGACY_IMPL_SLOT, ProxyKind, RUNG_LABELS, addressFromStorageWord, addressKey, availableOverrideRungs, blockArg, blockFromJson, blockKey, blockToJson, chainIdToNumber, contractRefKey, createBackendContractReader, createProxyOverridesClient, detectHop, directChain, formatBlockWindow, hasProvenance, isInherited, overrideQuery, parseBlock, proxyChainFromAddresses, proxyOverrideRequestBody, readerProxyDeps, resolveProxyChain, scopeRungLabel, toProvenance, windowCovers, windowViewBlock };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map